import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PopoverArrow as PopoverArrowPrimitive } from "@radix-ui/react-popover";
import cn from "../../../utils/cn";
const PopoverArrow = (props) => {
    const { className, ...otherProps } = props;
    return (_jsx(PopoverArrowPrimitive, { asChild: true, className: "-mt-[6px]", ...otherProps, children: _jsxs("svg", { className: cn("rotate-180 fill-white stroke-gray-light", className), width: "24", height: "24", viewBox: "0 0 64 64", strokeWidth: "3", xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [_jsx("title", { children: "PopoverArrow" }), _jsx("polyline", { points: "57.47 45.15 30.84 19.88 6.58 45.15" })] }) }));
};
export default PopoverArrow;
